
import React from 'react'
import { Controller } from 'react-hook-form'

import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import Icon from "react-multi-date-picker/components/icon"
import persian_en from "react-date-object/locales/persian_en"
const monthsInDari = [["حمل", "فر"], ["ثور", "ار"], ["جوزا", "خرد"], ["سرطان", "سرطان"], ["اسد", "مر"], ["سنبله", "شه"], ["ميزان", "مه"], ["عقرب", "آبا"], ["قوس", "آذ"], ["جدی", "جدی"], ["دلو", "بهم"], ["حوت", "اسف"]]
const weekDays = [["شنبه", "شنبه"], ["یکشنبه", "یک"], ["دوشنبه", "دو"], ["سه شنبه", "سه"], ["چهارشنبه", "چهار"], ["پنجشنبه", "پنج"], ["جمعه", "جمعه"]]

export default function APDate({ v }) {

    const onChangeDate = (unix, formatted) => {

        console.log(unix); // returns timestamp of the selected value, for example.
        console.log(formatted);
        v.setValue(v?.data?.name, formatted?.validatedValue[0])
    }

    return (
        <div >
            {!v.data?.isStyle && <p className="text-base text-black font-semibold amiriB">{v.data?.label} {v.data?.required&& <span className='text-red-700'>*</span>} </p>}

            <div className=" w-full border border-gray-00 rounded-md" style={{ direction: "rtl" }}>
                { <Controller
                    control={v.control}
                    rules={{ required: v.data.required }}
                    error={v.data.required}
                    name={v.data.name}
                 
                    render={({
                        field: { onChange, onBlur, value, name, ref },
                    }) => (!v?.data?.render ?<>
                        <DatePicker
                            months={monthsInDari}
                            weekDays={weekDays}
                            placeholder="انتخاب تاریخ"
                            calendar={persian}
                            value={value}
                            locale={persian_en}
                            onChange={onChangeDate}
                            disabled={v?.data?.isDisabled}
                            inputClass="pdatePicker"
                            onOpenPickNewDate={false}
                        />
                    </>: <DatePicker
                        onChange={onChangeDate}
                        onlyMonthPicker={v?.data?.onlyMonth}
                        onlyYearPicker={v?.data?.onlyYear}
                        months={monthsInDari}
                        value={value}
                        disabled={v?.data?.isDisabled}
                        placeholder="انتخاب تاریخ"
                        weekDays={weekDays}
                        calendar={persian}
                        format="YYYY/MM/DD"
                        locale={persian_en}
                        inputClass="pdatePicker"
                        onOpenPickNewDate={false}

                    />
                    )} /> 
                   
                }
                {v.errors[v.data?.name] && v.data.required && <small className="text-red-600">{v.data.required}</small>}
            </div>
        </div>

    )
}
// format="jYYYY/jMM/jDD"